
import { defineComponent } from 'vue'
import axios from 'axios'

import { billDetails } from '@/api/salary'

import searchComponent from '@/components/search-component/index.vue'
import tableComponent from '@/components/table-component/index.vue'
import {exportBillDetail} from "@/api/export";

export default defineComponent({
  components: {
    searchComponent,
    tableComponent
  },
  props: {
    serveCompanyId: {
      type: [String, Number],
      default: ''
    },
    startTime: {
      type: String,
      default: ''
    },
    endTime: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      // 操作状态(0 未领取 1 已领取 2 停止发薪 3进行中 4领取失败)
      statusMap: {
        0: '未领取',
        1: '已领取',
        2: '停止发薪',
        3: '进行中',
        4: '领取失败'
      },
      searchList: {
        searchInfo: {
          name: '搜索',
          prop: 'searchInfo',
          type: 'input',
          placeholder: '请输入人员信息',
          value: '',
          defaultValue: ''
        },
        status: {
          name: '领薪状态',
          prop: 'status',
          type: 'select',
          placeholder: '请选择',
          multiple: false,
          value: '',
          defaultValue: '',
          options: [
            {
              label: '全部',
              value: ''
            },
            {
              label: '未领取',
              value: 0
            },
            {
              label: '已领取',
              value: 1
            },
            {
              label: '停止发薪',
              value: 2
            }
          ],
          defaultAttrs: {
            label: 'label',
            value: 'value'
          }
        }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
      } as any,
      buttonList: [
        {
          name: '导出明细',
          buttonType: 'export',
          type: 'danger',
          fn: () => {
            this.onExport()
          }
        }
      ] as any,
      tableHead: [
        // {
        //   prop: 'index'
        // },
        {
          prop: 'userName',
          label: '姓名'
        },
        {
          prop: 'idCardNo',
          label: '身份证号',
          width: 170
        },
        {
          prop: 'projectName',
          label: '所属项目',
          width: 170
        },
        {
          prop: 'payTime',
          label: '发薪时间',
          width: 160
        },
        {
          prop: 'updateTime',
          label: '操作时间',
          width: 160
        },
        {
          prop: 'status',
          label: '操作状态'
        },
        {
          prop: 'detailRemarks',
          label: '发薪备注'
        }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
      ] as any,
      tableData: [] as any,
      pageInfo: {
        pageNum: 1,
        pageSize: 10,
        total: 0
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
      } as any,
      selects: []
    }
  },
  watch: {
    serveCompanyId: {
      handler(newval) {
        console.log(212121,newval);
        if (newval) {
          this.getData()
        }
      },
      immediate: true
    }
  },
  methods: {
    handleSelectionChange(row: any) {
      this.selects = row.map((item: any) => item.id)
    },
    createQuery(hasPage = true) {
      const query = {} as any
      if (hasPage) {
        query.pageNum = this.pageInfo.pageNum
        query.pageSize = this.pageInfo.pageSize
      }
      for (const key in this.searchList) {
        if (this.searchList[key].type === 'dateRange') {
          query[`begin${this.searchList[key].prop}`] = this.searchList[key].value?.length ? this.searchList[key].value[0] : ''
          query[`end${this.searchList[key].prop}`] = this.searchList[key].value?.length ? this.searchList[key].value[1] : ''
        } else if (this.searchList[key].type === 'select') {
          if (this.searchList[key].multiple) {
            query[(this.searchList[key]).prop] = this.searchList[key].value.join(',')
          } else {
            query[(this.searchList[key]).prop] = this.searchList[key].value
          }
        } else {
          query[(this.searchList[key]).prop] = this.searchList[key].value
        }
      }
      return query
    },
    handleSearch() {
      this.pageInfo.pageNum = 1
      this.getData()
    },
    handleSizeChange(ev: number) {
      this.pageInfo.pageSize = ev
      this.getData()
    },
    handleCurrentChange(ev: number) {
      this.pageInfo.pageNum = ev
      this.getData()
    },
    async getData() {
      const query = this.createQuery()
      query.serveCompanyId = (this as any).serveCompanyId
      query.beginPayTime = this.startTime
      query.endPayTime = this.endTime
      const res = await billDetails(query) as any
      this.tableData = res.list || []
      this.pageInfo.total = res.total || 0
    },
    async onExport () {
      const result = await exportBillDetail({
        serveCompanyId: this.serveCompanyId as string,
        beginPayTime: this.startTime,
        endPayTime: this.endTime,
        ...this.createQuery(false),
        queryStatus: this.searchList.status.value
      })
      window.location.href = process.env.VUE_APP_BASE_URL + '/common/download?delete=true&fileName=' + result

      this.$message.success('导出成功！')
    }
  }
})
